<ng-container *ngFor="let category of categories">
    <div class="addSensor" *ngIf="authService.isSuperAdmin">
        <button *ngIf="categories[0] === category"
        mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('sensor')"
        >Add Sensor</button>
    </div>
        
        <ng-container *ngIf="(sensors | filter: {kind : category.value}).length > 0">
            <div class="category-title">{{category.viewValue | uppercase}}</div>
            <div class="sensor-container">
                <app-sensor-overview class="sensor"
                                     *ngFor="let sensor of sensors | filter: {kind : category.value}"
                                     [sensor]="sensor"
                                     [showEdit]="true"
                                     (onSensorOpen)="updateCurrentZone(zone)"
                                     (onSensorUpdate)="updateSensors()"></app-sensor-overview>
            </div>
        </ng-container>
</ng-container>

